'use client';

import * as React from 'react';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';

import { cn } from '../../helpers/utils';

const TooltipProvider = TooltipPrimitive.Provider;

const Tooltip = TooltipPrimitive.Root;

const TooltipTrigger = TooltipPrimitive.Trigger;

const TooltipContent = React.forwardRef<
	React.ElementRef<typeof TooltipPrimitive.Content>,
	React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content>
>(({ className, sideOffset = 4, ...props }, ref) => (
	<TooltipPrimitive.Portal>
		<TooltipPrimitive.Content
			ref={ref}
			sideOffset={sideOffset}
			className={cn(
				'z-50 overflow-hidden rounded-md bg-primary px-3 py-1.5 text-xs text-primary-foreground animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2',
				className,
			)}
			{...props}
		/>
	</TooltipPrimitive.Portal>
));
TooltipContent.displayName = TooltipPrimitive.Content.displayName;

const GeneralTooltip = ({
	children,
	text,
	triggerClassName,
}: React.PropsWithChildren<{ text: string | React.ReactNode; triggerClassName?: string }>) => (
	<TooltipPrimitive.Provider delayDuration={0}>
		<Tooltip>
			<TooltipTrigger asChild className={triggerClassName}>
				{children}
			</TooltipTrigger>
			<TooltipContent style={{ zIndex: 1500 }}>
				{typeof text === 'string' ? <p style={{ whiteSpace: 'pre-line' }}>{text}</p> : text}
			</TooltipContent>
		</Tooltip>
	</TooltipPrimitive.Provider>
);

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider, GeneralTooltip };
